import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const examinationLocaleModule: LocaleModule = {
  name: "examination",
  messages: { en: en, it: it },
};
